import canMakeNewRankingRequest from "../shared/canMakeNewRankingRequest";
import { getField } from "../shared/fields";
import "./ranking.scss";
import moment from "moment/moment.js";
import { showAlert, showConfirm } from "../shared/modalTriggers";

class RankingController {
  constructor($limits, UserService, $searchManager, $location, $rankingSearchSettings, $seoMetaLengths, $resultsStore, $listManagementNotifier, $saveToList, $activeList, $notifier, $tokenManager, $keywordsCollection, $meta, Modal, $seeds, $lists, $stateParams, $timeout, $listNavigation, $rootScope, $requestManager, $searchDebug) {
    this.$limits = $limits;
    this.results = $resultsStore;
    this.$searchManager = $searchManager;
    this.$location = $location;
    this.$rankingSearchSettings = $rankingSearchSettings;
    this.$seoMetaLengths = $seoMetaLengths;
    this.user = UserService.user;
    this.isFreeUser = UserService.user.isFreeUser;
    this.settingsChanged = false;
    this.$listManagementNotifier = $listManagementNotifier;
    this.$saveToList = $saveToList;
    this.$activeList = $activeList;
    this.$notifier = $notifier;
    this.getField = getField;
    this.$keywordsCollection = $keywordsCollection;
    this.$tokenManager = $tokenManager;
    this.$meta = $meta;
    this.country = null;
    this.Modal = Modal;
    this.$seeds = $seeds;
    this.import = {};
    this.$lists = $lists;
    this.lists = $lists.lists;
    this.list = null;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.prevPage = -1;
    this.isNew = false;
    this.loading = true;
    this.moment = moment;
    this.listNav = $listNavigation;
    this.$rootScope = $rootScope;
    this.freshKeywords = [];
    this.$requestManager = $requestManager;
    this.$searchDebug = $searchDebug;
  }

  $onInit() {
    this.$tokenManager.getToken();
    this.$lists.initialize().then(this.loadList.bind(this));

  }

  loadList() {
    const { id } = this.$stateParams;
    const list = _.findWhere(this.lists, {id: parseInt(id) });
    if (!list) return this.$location.path(`/ranking`);
    this.setupFromList(list);

    this.freshKeywords = [];
    this.getKeywords({ page: 1}).then(fresh => {
      this.$timeout(() => {this.loading = false;}, 250);
      if (fresh.length > 0) {
        this.$rankingSearchSettings.searchParams.keywords = fresh;
        this.$searchManager.searchRanking();
        this.freshKeywords = [];
        showAlert("We have begun tracking your keywords! Please check back within fifteen minutes as we collate ranking information.");
      }
    });
  }

  setupFromList(list) {
    if (!list.ranking_last_updated) list.ranking_last_updated = moment();
    if (!list.ranking_next_update) list.ranking_next_update = moment().add(1, 'weeks');
    this.list = list;
    this.$rankingSearchSettings.searchParams.site = list.domain;
    this.$rankingSearchSettings.searchParams.list_id = list.id;
    this.country = list.countries[0];
    this.$rankingSearchSettings.searchParams.country = this.country;
    this.$requestManager.clearSearch('ranking');
    this.results.ranking = this.$keywordsCollection({name: 'ranking'});
    this.results.ranking.add([]);
    this.rankingKeywordsUsed = this.list.keywords_count;
    this.rankingKeywordsAvailable = Math.max(this.$limits.raw.ranking_keywords - this.rankingKeywordsUsed, 0);
  }

  // this.country = response.keywords[0].country;
  // this.$rankingSearchSettings.searchParams.country = this.country;

  async getKeywords({ page }) {

    const response = await this.$lists.getKeywords({
      id: this.list.id,
      page
    });

    if (this.prevPage >= response.page) return [];

    if (response.keywords.length === 0) {
      this.results.ranking.add([]);
      return this.freshKeywords;
    }

    this.addPage(response);
    this.prevPage = response.page;

    return this.getKeywords({page: response.page + 1});
  }

  addPage(response) {

    let hasPending = false;

    const keywords = response.keywords.map(keyword => {
      const canRequest = canMakeNewRankingRequest(keyword);
      const rankMissing = !keyword.rank;

      const settledKeyword             = (canRequest && !rankMissing);
      const freshKeyword               = (canRequest && rankMissing);

      if (settledKeyword) return keyword;

      if (freshKeyword) this.freshKeywords.push(keyword.keyword);

      hasPending = true;
      keyword.pending = true;

      return keyword;

    });

    if (keywords.length > 0) {
      this.results.ranking.add(keywords);
      this.results.ranking.updateCountsFromResponse(response);

      if (hasPending) {
        this.$requestManager.registerOutstandingRequest(this.list.id, 'ranking', this.results.ranking, 'ranking', 'ranking');
        this.$searchDebug.log('okay', 'ranking addPage called registerOutstandingRequest', {source: 'ranking', supplier: 'ranking'});
      }

    }
  }

  newImport() {
    this.import.bulkSeeds = null;
    this.import.bulkCSV = null;
    this.Modal.new({
      component: 'searchBulkModal',
      dismissable: true,
      bindings: {
        title: "Add keywords to track..."
      }
    }).then(keywords => {
      if (keywords.length > this.rankingKeywordsAvailable) {
        return this.$notifier.red(`Max of ${this.$limits.raw.ranking_keywords} keywords per list. You can import a maximum of ${this.rankingKeywordsAvailable} more.`);
      }
      this.importKeywords(keywords, this.country, 'ranking');
    }).catch(console.error);
  };

  importKeywords(keywords, country, source) {

    // De-dup with keywords already in collection
    const existingKeywords = this.results.ranking.keywords.map(keyword => keyword.keyword);
    keywords = _.difference(keywords, existingKeywords);

    if (keywords.length > 0) {
      // Save to list
      this.$lists.importKeywords(
        this.list,
        keywords.map(keyword => ({keyword, country, source}))
      ).then(res => {
        this.rankingKeywordsAvailable -= keywords.length;
        this.rankingKeywordsUsed += keywords.length;
      });

      this.$rankingSearchSettings.searchParams.keywords = keywords;
      this.$rankingSearchSettings.searchParams.country = this.country;
      keywords.reverse().forEach(keyword => this.results.ranking.addPending(keyword));
      this.$searchManager.searchRanking();

    }

  };

  deleteSelected() {
    let selectedKeywords = this.results.ranking.getActionable();

    if (selectedKeywords.length === 0) return false;

    showConfirm('Remove ' + selectedKeywords.length + ' keywords from this list?').then(() => {
      this.$lists.deleteKeywords(this.list, selectedKeywords).then(() => {
        var newKeywords = _.difference(this.results.ranking.keywords, selectedKeywords);
        this.results.ranking.keywords = newKeywords;
        this.results.ranking.selectedKeywords = [];
        this.results.ranking.count = newKeywords.length;
        this.rankingKeywordsAvailable += selectedKeywords.length;
        this.rankingKeywordsUsed -= selectedKeywords.length;
      });
    });
  }

}

RankingController.$inject = ['$limits', 'UserService', '$searchManager', '$location', '$rankingSearchSettings', '$seoMetaLengths', '$resultsStore', '$listManagementNotifier', '$saveToList', '$activeList', '$notifier', '$tokenManager', '$keywordsCollection', '$meta', 'Modal', '$seeds', '$lists', '$stateParams', '$timeout', '$listNavigation', '$rootScope', '$requestManager', '$searchDebug'];

export const ranking = {
  controller: RankingController,
  template: require('./ranking.html')
};